<template>
  <div class='calendar-app calendar-center'> 
    <div v-if="calendarKey > 0" class='calendar-app-main'>
      <FullCalendar class='calendar-app-calendar' :options="configOptions">
        <template v-slot:eventContent='arg'>
          <span :id="arg.id" v-if="arg.view.type === 'timeGridWeek'">
            <span>{{ arg.timeText }}</span>
            <br>
            <b>{{ arg.event.title }}</b>
            <br>
            <span v-if="arg.event.extendedProps">
              <span>{{$t('game.token')}}: </span>
              <span>{{arg.event.extendedProps.token_per_order}}</span>
            </span>
          </span>
          <b :id="arg.event.id" v-else>{{ arg.event.title }}</b>
        </template>
      </FullCalendar>
    </div>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
require('jquery-contextmenu')

import 'jquery-contextmenu/dist/jquery.contextMenu.min.css'

export default {
  components: {
    FullCalendar
  },
  props: ['dataEvents'],
  data: function() {
    return {
      calendarKey: 0,
      configOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin
        ],
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'timeGridWeek'
        },
        buttonText: {
          today: this.$t('common.today'),
          month: this.$t('common.month'),
          week: this.$t('common.week')
        },
        events: [],
        eventColor: '#0091ff',
        locale: this.$session.get('lang'),
        initialView: 'timeGridWeek',
        nextDayThreshold: '00:00',
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        },
        editable: false,
        selectable: false,
        selectMirror: false,
        dayMaxEvents: true,
        weekends: true,
        droppable: false,
        eventDidMount: this.eventDidMount,
        dateClick: this.dateClick,
      },
    }
  },
  created () {
  },
  watch: {
    dataEvents (newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        this.calendarKey += 1
        const calendarEvents = JSON.parse(JSON.stringify(newValue))
        calendarEvents.forEach(element => {
          element.title = element.name
          element.endRecur = this.addDays(element.endRecur, 1)
        });
        this.configOptions.events = calendarEvents
      } else {
        this.calendarKey += 1
        this.configOptions.events = []
      }
    }
  },
  mounted () {
    const vm = this
    vm.calendarKey += 1
    window.$.contextMenu({
      // define which elements trigger this menu
      selector: ".fc-event",
      // define the elements of the menu
      items: {
        "edit": {name: vm.$t('edit_game_rule'), icon: "edit", disabled: (key, options) => {
          const eventId = options.$trigger.attr("data-event-id")
          const arrs = vm.dataEvents.filter(element => {
            return Number(element.id) === Number(eventId)
          })
          return arrs.length > 0 && arrs[0].is_grant_user
        }},
        "delete_date": {name: vm.$t('delete_date'), icon: "cut"},
        "delete": {name: vm.$t('delete_game_rule'), icon: "delete"},
      },
      // there's more, have a look at the demos and docs...
      callback: function(key, options) {
        const eventId = options.$trigger.attr("data-event-id")
        const arrs = vm.dataEvents.filter(element => {
          return Number(element.id) === Number(eventId)
        })
        if (key === 'edit') {
          vm.showModalUpdate(arrs.length > 0 && arrs[0], null)
        } else if (key === 'delete_date') {
          const date = options.$trigger.attr("data-date")
          vm.handleDeleteDate(arrs.length > 0 && arrs[0], date)
        } else {
          vm.deleteEventData(arrs.length > 0 && arrs[0])
        }
      },
    });
  },
  methods: {
    eventDidMount: function (info) {
      const timezone = this.$const.CLIENT_TIMEZONE[this.$store.getters.config.base.id] || this.$moment.tz.guess()
      const date = this.convertDateTimeToLocal(info.event.start, timezone, 30)
      window.$(info.el).attr('data-event-id', info.event.id);
      window.$(info.el).attr('data-date', date);
      window.$(info.el).attr('id', info.event.id + '-' + date);
      const arrs = this.dataEvents.filter(element => {
        return Number(element.id) === Number(info.event.id)
      })
      if (arrs.length > 0 && arrs[0].special_dates && arrs[0].special_dates.includes(date)) {
        window.$(info.el).addClass('event-special-date');
      }
    },
    dateClick: function (info) {
      this.$emit('openUpdateEvent', null, info.dateStr)
    },
    showModalUpdate (item, date) {
      this.$emit('openUpdateEvent', item, date)
    },
    deleteEventData(item) {
      this.$emit('deleteGameRuleEvent', item)
    },
    handleDeleteDate (item, date) {
      if (item) {
        if (!item.special_dates) {
          item.special_dates = []
        }
        item.special_dates.push(date)
      }
      document.getElementById(`${item.id}-${date}`).remove()
    }
  }
}
</script>

<style lang='css'>
h2 {
  margin: 0;
  font-size: 16px;
}

ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}

li {
  margin: 1.5em 0;
  padding: 0;
}

b { /* used for event dates/times */
  margin-right: 3px;
}

.calendar-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
  position: relative;
}

.calendar-app-main {
  width: 100%;
  padding: 1rem;
}

.fc { /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}
/* button month and week */
.fc-event-main {
  font-size: 14px;
}
.fc .fc-button-primary {
  background-color:#fff;
  border-color: #0091ff;
  color: #9fa1a3;
}
.fc .fc-button-primary:hover {
  background: #0091ff;
}
.fc .fc-button-primary:not(:disabled).fc-button-active, .fc .fc-button-primary:not(:disabled):active {
  background-color: #0091ff;
  border-color: #0091ff;
  color: #fff;
}
/* button today */
.fc .fc-button-primary:disabled {
  background-color:#0091ff;
  border-color: #0091ff;
  color: #fff;
}
/* title */
.fc-toolbar-chunk {
  color: #0091ff;
}
.fc .fc-dayGridMonth-view .fc-daygrid-day-events {
  background-color:#0091ff;
}
.fc .fc-dayGridMonth-view .fc-daygrid-day-events a {
  color: #fff;
}
.btn-new-event {
  position: absolute;
}
.context-menu-item {
  margin: 5px 10px;
}
.fc-timegrid-event-harness-inset {
  left: 0 !important;
}
.event-special-date {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Partials/FullCalendar.vue